import type { SVGProps } from 'react';

const WarningSymbol = ({
  width = 20,
  height = 20,
  viewBox = '0 0 20 20',
  fill = 'none',
  color = 'var(--highlight)',
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill={fill}
    color={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 19.167A9.166 9.166 0 0 1 .833 10 9.166 9.166 0 0 1 10 .833 9.166 9.166 0 0 1 19.167 10 9.166 9.166 0 0 1 10 19.167Zm0-1.834a7.333 7.333 0 1 0 0-14.666 7.333 7.333 0 0 0 0 14.666Zm-.917-4.583h1.834v1.833H9.083V12.75Zm0-7.333h1.834v5.5H9.083v-5.5Z"
      fill="currentColor"
    />
  </svg>
);

export default WarningSymbol;
